import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=456bd04e&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=456bd04e&prod&lang=less&scoped=true&"
import style1 from "./edit.vue?vue&type=style&index=1&id=456bd04e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456bd04e",
  null
  
)

export default component.exports